import { useState, type ReactElement } from 'react';
import { createGlobalStyle } from 'styled-components';
import MuiTooltip from '@mui/material/Tooltip';
import makeStyles from '@mui/styles/makeStyles';
import TitleComponent from './TitleComponent';
import { commonStyles } from './sharedStyles';

const useMobileStyles = makeStyles({
  ...commonStyles,
  tooltip: {
    ...commonStyles.tooltip,
    minWidth: '99vw',
  },
});

const FakeOverlay = createGlobalStyle`
  #page-template, #root {
    opacity: 0.5;
  }
`;

interface TooltipMobileProps {
  children: ReactElement;
  maxWidth?: string;
  title?: string | ReactElement;
}

const TooltipMobile = ({ children, title, ...props }: TooltipMobileProps) => {
  const [open, setOpen] = useState(false);
  const classes = useMobileStyles();

  const handleClose = () => setOpen(false);

  return (
    <>
      {open && <FakeOverlay />}
      <MuiTooltip
        open={open}
        classes={classes}
        enterTouchDelay={300}
        leaveTouchDelay={5000}
        onClose={handleClose}
        onOpen={() => setOpen(true)}
        title={<TitleComponent title={title} onClose={handleClose} />}
        {...props}
        arrow={false}
        placement="top"
      >
        {children}
      </MuiTooltip>
    </>
  );
};

export default TooltipMobile;
export type { TooltipMobileProps };
